import { createAction, props } from '@ngrx/store';
import {
  MajorModel,
  OccupationQuickMatchModel
} from '@cpd-app/core-module/models';

export const setMajor = createAction(
  '[Major] Set Major',
  props<{ majorModel: MajorModel }>()
);

export const removeMajor = createAction('[Major] Remove Major');

export const receivedOccupationList = createAction(
  '[Occupations By Major] Received Occupations',
  props<{ entities: OccupationQuickMatchModel[] }>()
);
